const SuccessSteps: React.FC = () => {
  return (
    <section className="my-10">
      <div className="mb-10 border-b-8 border-gray-100 pb-2">
        <h3 className="container text-lg font-semibold uppercase">
          How we succeed
        </h3>
      </div>
      <ul className="container mb-20 grid grid-cols-2 gap-10 md:grid-cols-4 lg:gap-20">
        {[
          [
            "https://prmf.co.uk/lib-module-succeed-icon-innovation-efb74e2.svg",
            "Innovation",
            "Moving up the value chain through innovation & improvement in all areas of our business.",
          ],
          [
            "https://prmf.co.uk/lib-module-succeed-icon-great-place-to-work-efb74e2.svg",
            "A great place to work",
            "Creating an environment where we can all work at our best.",
          ],
          [
            "https://prmf.co.uk/lib-module-succeed-icon-winning-with-customers-efb74e2.svg",
            "Winning with customers",
            "Being service partner of choice, delivering profitable sales.",
          ],
          [
            "https://prmf.co.uk/lib-module-succeed-icon-great-at-what-we-do-efb74e2.svg",
            "Great at what we do",
            "Best in class, consistent repeatable delivery.",
          ],
        ].map(([img, title, text]) => (
          <li key={title} className="space-y-4 text-xs">
            <div
              className="h-12 w-12 rounded bg-gray-400 bg-[length:75%] bg-center bg-no-repeat"
              style={{ backgroundImage: `url(${img})` }}
            />
            <h4 className="border-t border-gray-400 pt-4 font-semibold">
              {title}
            </h4>
            <p>{text}</p>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default SuccessSteps;
